import React from 'react';
import { FormattedMessage } from '@kyruus/intl';
import ArrowDown3 from '@kyruus/react-ikons/ArrowDown3';

import { UnappliedFilterChip, UnappliedFilterChipLabel } from '../../styles';
import { CHIP_ROLE } from '../../constants';
import { getChipMessage } from '../utils';
import { BaseChipProps } from '.';

export const UnappliedChip = ({
  facet,
  index,
  onClick,
  log,
  ...props
}: BaseChipProps) => {
  const message = getChipMessage(facet);

  return (
    <UnappliedFilterChip
      {...props}
      label={
        <UnappliedFilterChipLabel>
          <FormattedMessage {...message} />
          <ArrowDown3 size="1.6em" aria-hidden="true" />
        </UnappliedFilterChipLabel>
      }
      onClick={onClick}
      role={CHIP_ROLE}
      data-index={index}
    />
  );
};
